export default "__VITE_ASSET__BcDZtQ0p__"